export const maxFileSizeBytes = 1024 * 1024 * 10
export const maxNoOfDocumentsInOneUpload = 5;
export const maxLanguagesFamily = 2;
export const maxLanguagesNanny = 4;

// Text field limits
export const maxNameLength = 50;
export const maxPhoneNoLength = 20;
export const maxCurrentEmploymentLength = 100;
export const maxCityLength = 30;
export const maxPostCodeLength = 10;
export const maxStreetAndHouseNoLength = 100;
export const maxCustomerCommentLength = 1000;
export const maxSpecificAvailabilityByPhoneLength = 50;
export const maxSpecialCareTextLength = 1000;
export const maxDeclineReasonCustomerLength = 1000;
export const maxContactQueryMessageLength = 5000
export const maxUsernameLength = 150
export const maxPasswordLength = 100;
